import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import Toast from "components/WMS/Toast";

import RedWarning from "assets/img/redWarning.svg"

ProductNotFoundToast.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func
};

function ProductNotFoundToast({open = false, handleClose = () => {}, ...props}) {
    return (
        <Toast
            icon={(
                <img
                    src={RedWarning}
                    alt={props.intl.formatMessage({id: 'wms.myPickingMissions.product.notFound.title'})}
                    style={{width: '20px', height: '20px'}}
                />
            )}
            title={<FormattedMessage id={'wms.myPickingMissions.product.notFound.title'} />}
            open={open}
            handleClose={handleClose}
            disablePortal={false}
        />
    );
}

export default injectIntl(ProductNotFoundToast);
